import React from 'react';
import { format, isToday, isYesterday, isSameDay } from 'date-fns';
import Icon from '../../../components/AppIcon';

const ConversationArea = ({ messages, currentUserId, messagesEndRef, formatMessageTime }) => {
  const formatDateSeparator = (date) => {
    if (isToday(date)) return 'Today';
    if (isYesterday(date)) return 'Yesterday';
    return format(date, 'MMMM d, yyyy');
  };

  const shouldShowDateSeparator = (currentMsg, prevMsg) => {
    if (!prevMsg) return true;
    const currentDate = new Date(currentMsg?.createdAt);
    const prevDate = new Date(prevMsg?.createdAt);
    return !isSameDay(currentDate, prevDate);
  };

  return (
    <div className="flex-1 overflow-y-auto p-4 space-y-4">
      {messages?.length > 0 ? (
        messages?.map((message, index) => {
          const isSent = message?.senderId === currentUserId;
          const showDateSeparator = shouldShowDateSeparator(message, messages?.[index - 1]);

          return (
            <React.Fragment key={message?.id}>
              {/* Date Separator */}
              {showDateSeparator && (
                <div className="flex items-center justify-center my-4">
                  <div className="px-3 py-1 rounded-full" style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.08)' }}>
                    <p className="text-xs font-medium" style={{ color: 'rgba(255,255,255,0.4)', fontFamily: "'Inter Tight', 'Inter', sans-serif" }}>
                      {formatDateSeparator(new Date(message?.createdAt))}
                    </p>
                  </div>
                </div>
              )}
              {/* Message Bubble */}
              <div className={`flex ${isSent ? 'justify-end' : 'justify-start'}`}>
                <div
                  className="max-w-[70%] rounded-2xl px-4 py-2"
                  style={
                    isSent
                      ? {
                          background: 'linear-gradient(135deg, rgba(0,212,255,0.25) 0%, rgba(0,212,255,0.15) 100%)',
                          border: '1px solid rgba(0,212,255,0.3)',
                          borderBottomRightRadius: '4px',
                          boxShadow: '0 0 12px rgba(0,212,255,0.1)',
                        }
                      : {
                          background: 'rgba(255,255,255,0.06)',
                          border: '1px solid rgba(255,255,255,0.09)',
                          borderBottomLeftRadius: '4px',
                        }
                  }
                >
                  <p className="text-sm leading-relaxed break-words" style={{ color: '#fff' }}>{message?.content}</p>
                  <div className="flex items-center justify-end gap-1 mt-1">
                    <p className="text-xs" style={{ color: isSent ? 'rgba(0,212,255,0.6)' : 'rgba(255,255,255,0.3)' }}>
                      {formatMessageTime(message?.createdAt)}
                    </p>
                    {isSent && (
                      <Icon
                        name={message?.status === 'read' ? 'CheckCheck' : 'Check'}
                        size={14}
                        style={{ color: message?.status === 'read' ? '#00D4FF' : 'rgba(0,212,255,0.4)' }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </React.Fragment>
          );
        })
      ) : (
        <div className="flex items-center justify-center h-full">
          <div className="text-center">
            <Icon name="MessageSquare" size={48} className="mx-auto mb-4" style={{ color: 'rgba(255,255,255,0.15)' }} />
            <p className="font-medium" style={{ color: 'rgba(255,255,255,0.4)', fontFamily: "'Inter Tight', 'Inter', sans-serif" }}>No messages yet</p>
            <p className="text-sm mt-2" style={{ color: 'rgba(255,255,255,0.25)' }}>Start the conversation!</p>
          </div>
        </div>
      )}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default ConversationArea;